import { Stack } from "@mui/joy";
import { ProgramContentType } from "data/BlockComponent";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { setProgramContentData } from "logic/logics";
import { theme } from "styles/theme";
import "dayjs/locale/ko"; // 한국어 로케일 import

export default function DateSelectCell({
  defaultValue,
  blockIndex,
  setData,
  lineIndex,
  cellIndex,
  editorKey,
}: {
  defaultValue?: string;
  blockIndex: number;
  setData: React.Dispatch<
    React.SetStateAction<ProgramContentType[] | undefined>
  >;
  lineIndex: number;
  cellIndex: number;
  editorKey?: string;
}) {
  // 날짜 칸의 일부만 지우거나 없는 날짜(2월 31일 등)를 입력하면 DatePicker 는 null 이 아니라
  // Invalid Date 객체를 onChange 로 넘긴다. dayjs 는 그 값을 예외 없이 "Invalid Date" 문자열로
  // 포맷하므로, 검사 없이 저장하면 그 문자열이 그대로 기록에 남는다.
  const handleChange = (value?: Dayjs) => {
    if (!value?.isValid()) return;

    setProgramContentData({
      setData,
      blockIndex,
      lineIndex,
      cellIndex,
      newlyAddedData: { value: value.format("YYYY-MM-DD") },
    });
  };

  // 이미 "Invalid Date" 가 저장된 기록은 필드를 빈 상태로 열어 다시 선택할 수 있게 한다.
  const parsedDefaultValue = dayjs(defaultValue);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"ko"}>
      <Stack>
        <DatePicker
          key={`${editorKey}`}
          defaultValue={
            parsedDefaultValue.isValid() ? parsedDefaultValue : undefined
          }
          slotProps={{
            toolbar: {
              toolbarFormat: "MMMM DD일",
            },
            textField: {
              inputProps: { "data-disable-autofocus": true },
              sx: {
                border: "0px",
                minHeight: 0,
                backgroundColor: "white",
                borderRadius: "6px",
                height: "48px",
                "& .MuiInputBase-root": {
                  height: "100%", // 내부 입력 필드의 높이 조정
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: theme.vars.palette.divider, // 경계 색상 설정 (선택 사항)
                },
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: theme.vars.palette.divider,
                  },
                  "&.Mui-focused fieldset": {
                    borderWidth: "1.4px", // 포커스 상태에서의 borderWidth
                    borderColor: theme.vars.palette.primary.solid,
                  },
                },
              },
            },
            actionBar: {
              actions: ["cancel", "accept"],
            },
          }}
          localeText={{
            cancelButtonLabel: "취소",
            okButtonLabel: "확인",
            toolbarTitle: "날짜를 선택하세요",
          }}
          onChange={(value) => {
            if (value) {
              handleChange(value);
            }
          }}
        />
      </Stack>
    </LocalizationProvider>
  );
}
